import React from 'react'
import Navbar from './Navbar'
import BloodRequest from './BloodRequest'
import Footer from './Footer'

export default function BloodRequestPage() {
  return (
    <>
        <Navbar/>
        <BloodRequest/>
        <Footer/>
    </>
  );
};
